export default "__VITE_ASSET__c88499ab__"